export default {"src":"/_next/static/media/dobrozem-sucess.a70dc040.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};